import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Overview from "components/Next/Overview/Overview";

import * as nextOverviewReducer from "containers/Next/Overview/OverviewReducer";

class OverviewContainer extends React.Component {
  constructor(props) {
    super(props);

    props.init();
  }

  render() {
    const { isLoading } = this.props;

    console.log(isLoading);

    return isLoading ? <LoadingIndicator /> : <Overview {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => dispatch(nextOverviewReducer.init()),

    handleProjectClick: (nextId, datasetId) => dispatch(nextOverviewReducer.handleProjectClick(nextId, datasetId))
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    hexMap: nextOverviewReducer.getHexMap(state),
    actionHexMap: nextOverviewReducer.getActionHexMap(state),
    selectedHex: nextOverviewReducer.getSelectedHex(state),

    isLoading: nextOverviewReducer.getIsLoading(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OverviewContainer);
